<template>
    <modal-in-out>
        <div class="modal" v-if="showErrorModal" :class="{ 'is-active': showErrorModal }">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head has-background-primary">
                    <p class="modal-card-title has-text-white">No dataset found</p>
                </header>
                <section class="modal-card-body">
                    <p>No entry in the dataset catalog corresponds to this URL.</p>
                    <p class="content">
                    <ul>
                        <li>If you copied and pasted this URL, please make sure you included all characters.</li>
                        <li>Search for the entry in the <a @click="backToCatalog()">dataset catalog</a>.</li>
                    </ul>
                    </p>
                </section>
                <footer class="modal-card-foot is-justify-content-center">
                    <button class="button is-primary" @click="backToCatalog()">Go to Dataset Catalog</button>
                </footer>
            </div>
        </div>
    </modal-in-out>
</template>


<script>
import { mapStores } from 'pinia'
import { useDatasetCatalogStore } from '@/store/datasetCatalog'
const modalInOut = () => import("@/components/transitions/modalInOut");

export default {
    name: 'AppErrorModal',
    data() {
        return {
            // Data properties
            isLoading: false,
            selectedTab: 'details',
            scrollMax: 0
        }
    },
    components: {
        modalInOut,
    },
    computed: {
        ...mapStores(
            useDatasetCatalogStore,
        ),
        showErrorModal() {
            return this.datasetCatalogStore.isError
        },

    },
    methods: {

        backToCatalog(routeName) {
            let name = (routeName)? routeName : 'datasetCatalog'
            // Clear error
            this.datasetCatalogStore.isError = false
            // If the version depth is greater than 0, decrement it
            if (this.datasetCatalogStore.versionDepth > 0) {
                this.datasetCatalogStore.versionDepth -= 1
            }
            // If the user came from the catalog, go back one in the history (as if it went back in the browser)
            this.$router.replace({ name: name })

        },
    }

}
</script>
